import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {

    connect() {
        let timeout;
        let input = this.element.querySelector('.qty');
        let cart_item_key = this.element.hasAttribute('data-update-quantity') ? this.element.getAttribute('data-update-quantity') : false;
        let product_id = this.element.hasAttribute('data-product_id') ? this.element.getAttribute('data-product_id') : false;

        this.element.addEventListener('click', (e) => {
            const matchesDecrease = e.target.matches('.quantity-dec, .quantity-dec *');
            const matchesIncrease = e.target.matches('.quantity-inc, .quantity-inc *');
            if (matchesDecrease || matchesIncrease) {
                e.stopPropagation();
                e.preventDefault();
            }
        });

        this.element.addEventListener('mousedown', (e) => {
            const matchesDecrease = e.target.matches('.quantity-dec, .quantity-dec *');
            const matchesIncrease = e.target.matches('.quantity-inc, .quantity-inc *');
            if (matchesDecrease || matchesIncrease) {
                e.stopPropagation();
                e.preventDefault();

                let val = input.value ? parseInt(input.value) : 1;
                if (matchesDecrease) {
                    input.value = val > 1 ? val - 1 : val;
                } else if (matchesIncrease) {
                    if (input.hasAttribute('max') && input.getAttribute('max') ) {
                        input.value = val < input.getAttribute('max') ? val + 1 : val;
                    } else {
                        input.value = val + 1;
                    }
                }

                input.dispatchEvent(new Event('change', { 'bubbles': true }));
            }
        });

        input.addEventListener('change', () => {
            const update_cart_btn = document.querySelector('[name="update_cart"]');
            if (update_cart_btn) {
                if (timeout !== undefined) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(() => {
                    update_cart_btn.click();
                }, 800);
            }

            // Cart item quantity update;
            if (cart_item_key) {
                if (timeout !== undefined) {
                    clearTimeout(timeout);
                }

                timeout = setTimeout(async () => {
                    try {
                        await Axios.post(`${theme.rest_route}cart/quantity/`, {
                            qty: input.value,
                            product_id: product_id,
                            cart_item_key: cart_item_key,
                        }, {
                            headers: {'X-WP-Nonce': theme.nonce}
                        });

                        document.dispatchEvent( new CustomEvent('woocommerce_update_fragments'));

                    } catch (error) {}
                }, 300);
            }
        });
    }
}